import React, { useEffect } from 'react';
import { useParams, Redirect } from 'react-router-dom';
import HtmlHead from 'components/html-head/HtmlHead';
import JudgeDataProvider from 'data/JudgeDataProvider';
import { GetEventJudgeStore } from 'SessionState/Judge/EventJudgeStore';
import { localScoreRepository } from 'Repositories/Local/localScoreRepository';

type RouteParams = {
  eventJudgeId: string;
  eventId: string;
};

type JudgePortalShellProps = {
  title: string;
  description: string;
  children: React.ReactNode;
};

const JudgePortalShell: React.FC<JudgePortalShellProps> = ({
  title,
  description,
  children,
}) => {
  const { eventJudgeId, eventId } =
    useParams<RouteParams>();

  const judgeStore = GetEventJudgeStore();

  const parsedEventJudgeId = Number(eventJudgeId);
  const parsedEventId = Number(eventId);

  const judge = judgeStore.CurrentJudge;

  useEffect(() => {
    void localScoreRepository.cleanupOldSnapshots();
  }, []);

  if (!judge) {
    return <Redirect to="/judge/login" />;
  }

  if (
    Number(judge.id) !== parsedEventJudgeId ||
    Number(judge.eventId) !== parsedEventId
  ) {
    return <Redirect to="/judge/login" />;
  }

  return (
    <>
      <HtmlHead
        title={title}
        description={description}
          image="/img/background/HT_JudgePortal.png"
      />

      <JudgeDataProvider
        eventJudgeId={parsedEventJudgeId}
        eventId={parsedEventId}
      >
        {children}
      </JudgeDataProvider>
    </>
  );
};

export default JudgePortalShell;